/**
 * "Is this user an administrator?" — the frontend half of the backend's
 * `hasFullAccess()` in auth/admin-groups.ts.
 *
 * Two groups qualify: 'admin_' (full rights inside one tenant) and 'super_admin_'
 * (cross-tenant operator). Compared canonically, because StartupCleanupService
 * rewrites every stored Group.name to lowercase with exactly one trailing
 * underscore on boot — so 'Admin', 'admin' and 'admin_' are the same group, and a
 * name that has not been through that cleanup yet still resolves correctly.
 *
 * THIS ONLY HIDES THINGS. Every endpoint that matters refuses a non-admin on its
 * own (integration settings, the data-sheet import), so a direct call gains
 * nothing. Keep it that way: a check that lives only here is not access control.
 *
 * Extracted because this logic had already been written twice — on the
 * integration screen and in the sidebar — and a third copy in the data-sheet
 * buttons would have been three places to keep in step with one backend rule.
 */
const FULL_ACCESS_GROUPS = ['admin_', 'super_admin_'];

export function isAdminGroup(groupName?: string | null): boolean {
  const raw = String(groupName ?? '').trim().toLowerCase();
  if (!raw) return false;
  return FULL_ACCESS_GROUPS.includes(raw.replace(/_+$/, '') + '_');
}
